import { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function LegalPage({
  title,
  description,
  path,
  updatedAt,
  intro,
  sections,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F5F5F2]" data-testid={`legal-page-${path.replace(/\//g, "")}`}>
      <SEO
        title={title}
        description={description}
        path={path}
        robots="noindex, nofollow, noarchive, nosnippet"
      />

      <section className="bg-[#21324D] py-20 sm:py-24">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <p className="font-body text-sm uppercase tracking-[0.18em] text-[#A7A55C] mb-6">Legal</p>
          <h1 className="font-heading font-semibold text-4xl sm:text-5xl text-[#F5F5F2] leading-tight tracking-tight mb-6">
            {title}
          </h1>
          <p className="font-body text-base text-[#F5F5F2]/75 leading-relaxed max-w-3xl">
            {description}
          </p>
          <p className="font-body text-sm text-[#F5F5F2]/45 mt-6">
            Last updated {updatedAt}
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="bg-white border border-[#383A46]/10 p-8 sm:p-10">
            <p className="font-body text-base text-[#383A46] leading-[1.8] mb-10">
              {intro}
            </p>

            <div className="space-y-10">
              {sections.map((section) => (
                <section key={section.heading}>
                  <h2 className="font-heading font-semibold text-2xl text-[#21324D] tracking-tight mb-4">
                    {section.heading}
                  </h2>
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="font-body text-base text-[#383A46] leading-[1.8] mb-4">
                      {paragraph}
                    </p>
                  ))}
                  {section.items?.length > 0 && (
                    <ul className="list-disc pl-6 space-y-3">
                      {section.items.map((item) => (
                        <li key={item} className="font-body text-base text-[#383A46] leading-[1.8]">
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-[#383A46]/10">
              <p className="font-body text-sm text-[#383A46]/75 leading-relaxed">
                Questions about this page can be sent to{" "}
                <a href="mailto:hello@bitgenix.io" className="text-[#A7A55C] hover:text-[#8C8A4A] underline underline-offset-4">
                  hello@bitgenix.io
                </a>
                . You can also return to the{" "}
                <Link to="/" className="text-[#A7A55C] hover:text-[#8C8A4A] underline underline-offset-4">
                  homepage
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
